// extracted by mini-css-extract-plugin
export default {"container":"ArticleReferenceList_container__N8V25","placeholder":"ArticleReferenceList_placeholder__QkWQQ"};